import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useState } from 'react'
import API from '../../../../services/API'
import { TenantSettingsContext } from '../../../../App'
import MedicineSelector from './MedicineSelector'
import MedicinesInvolvedList from './MedicinesInvolvedList'
import Administration from '../../medsMx/Administration'
import { IncidentContext } from './ReportIncident'

const Step6 = () => {
  const { formValues, setFormValues, setTab } = useContext(IncidentContext)
  const [medicinesInvolved, setMedicinesInvolved] = useState(
    formValues?.medicinesInvolvedBoolean ?? ''
  )
  const [bagList, setBagList] = useState([])
  const [selectedMedsBag, setSelectMedsBag] = useState('')
  const [drugsToRemove, setDrugsToRemove] = useState([])
  const [medicinesInvolvedNoAction, setMedicinesInvolvedNoAction] = useState(
    formValues?.medicinesInvolvedNoAction ?? [],
  )
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  const handleNext = (e) => {
    e.preventDefault()
    setFormValues((prev) => ({
      ...prev,
      medicinesInvolvedBoolean: medicinesInvolved,
      relatedMedsBag: selectedMedsBag,
      drugsToRemove,
      medicinesInvolvedNoAction,
    }))
    setTab((prev) => prev + 1)
    window.scrollTo(0, 0)
  }

  const handleMedsInvolved = (e) => {
    if (e.target.value === 'Yes' && bagList.length === 0) {
      API.get('/medsmx/bags')
        .then((res) => setBagList(res.data))
        .catch(() => setBagList([]))
    }
    setMedicinesInvolved(e.target.value)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={3}
      onSubmit={handleNext}
      component="form"
    >
      <Typography variant="title2" fontSize="1rem">
        Medicines
      </Typography>
      <FormControl>
        <InputLabel id="medicinesInvolved-label">
          Were any {orgSettings.orgName} medicines involved in the Incident?
        </InputLabel>
        <Select
          labelId="medicinesInvolved-label"
          label={`Were any ${orgSettings.orgName} medicines involved in the Incident?`}
          id="medicinesInvolved"
          value={medicinesInvolved}
          required
          onChange={handleMedsInvolved}
        >
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </Select>
      </FormControl>
      {medicinesInvolved === 'Yes' && (
        <Box display="flex" flexDirection="column" gap={3}>
          <Box display="flex" flexDirection="column" gap={2}>
            <Typography variant="title3" fontSize="0.95rem">
              Medicines to remove from the bag
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Only for stock that's still physically in a bag and needs
              taking out now - e.g. destroyed or lost. If a medicine was
              already administered, or already removed some other way, use
              &quot;Other medicines involved&quot; below instead.
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="medsBag-label">
                Select the Medicine Bag involved
              </InputLabel>
              <Select
                labelId="medsBag-label"
                id="medsBag"
                value={selectedMedsBag}
                label="Select the Medicine Bag involved"
                onChange={(e) => setSelectMedsBag(e.target.value)}
              >
                {bagList.map((bag) => (
                  <MenuItem value={bag._id} key={bag._id}>
                    <Box display="flex" gap={2} alignItems="center">
                      <Typography variant="title3" fontSize="0.875">
                        {bag.name}
                      </Typography>
                      <Chip
                        color={
                          bag.level === 'Advanced'
                            ? 'error'
                            : bag.level === 'Intermediate'
                            ? 'warning'
                            : 'info'
                        }
                        label={bag.level}
                        sx={{ borderRadius: 1 }}
                      />
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {selectedMedsBag && (
              <Box>
                <MedicineSelector
                  selectedBagID={selectedMedsBag}
                  drugsToRemove={drugsToRemove}
                  setDrugsToRemove={setDrugsToRemove}
                />
              </Box>
            )}
          </Box>

          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="title3" fontSize="0.95rem">
              Other medicines involved
            </Typography>
            <MedicinesInvolvedList
              selected={medicinesInvolvedNoAction}
              setSelected={setMedicinesInvolvedNoAction}
            />
          </Box>
        </Box>
      )}
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setTab((prev) => prev - 1)}
        >
          Previous
        </Button>
        <Button variant="contained" color="primary" type="submit">
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default Step6
